import Vue from "vue";
import flatten, { unflatten } from "flat";

const state = Vue.observable({});

class SimpleStore {
  constructor() {
    this.state = state;
    this.listeners = [];
  }

  setState(data) {
    const flat = flatten(data ? data : {});
    for (const key in flat) {
      Vue.set(state, key, flat[key]);
    }

    this.broadcast(
      {
        type: "set",
      },
      JSON.parse(JSON.stringify(state))
    );
  }

  set(path, value) {
    const stateCopy = { ...state };
    const oldValue = stateCopy[path];
    stateCopy[path] = value;
    const mutation = {
      type: "set",
      path: path,
      value: value,
      oldValue: oldValue,
    };
    Vue.set(state, path, value);
    this.broadcast(mutation, stateCopy);
  }

  add(path, value) {
    if (Array.isArray(state[path])) {
      state[path].push(value);
    }
  }

  setLocal(path, value) {
    state[path] = value;
  }

  getState() {
    return unflatten(state);
  }

  get(path) {
    return state[path];
  }

  async setAsync(path, value) {
    this.set(path, value);
  }

  subscribe(id, callback) {
    if (
      this.listeners &&
      this.listeners.length &&
      !this.listeners.some((l) => l.id === id)
    ) {
      this.listeners.push({
        id: id,
        callback: callback,
      });

      return;
    }

    this.listeners = [];
    this.listeners.push({
      id: id,
      callback: callback,
    });
  }

  broadcast(mutation, stateCopy) {
    for (const listener of this.listeners) {
      listener.callback(mutation, stateCopy);
    }
  }
}

export default SimpleStore;
